import { render, staticRenderFns } from "./Pace.vue?vue&type=template&id=370a5400&"
import script from "./Pace.vue?vue&type=script&lang=js&"
export * from "./Pace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports